import { render, staticRenderFns } from "./BuyTheLookInput.vue?vue&type=template&id=01f1171b&scoped=true"
import script from "./BuyTheLookInput.vue?vue&type=script&lang=js"
export * from "./BuyTheLookInput.vue?vue&type=script&lang=js"
import style0 from "./BuyTheLookInput.vue?vue&type=style&index=0&id=01f1171b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1171b",
  null
  
)

export default component.exports